import {
	Box,
	Button,
	Typography,
	Modal,
	Paper,
	Dialog,
	Divider,
	DialogContent,
	DialogTitle,
	DialogActions,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog } from '../../services/features/dialogSlice/dialogSlice';
import { RootState } from '../../store';

/**
 * RemoveProductModal component displays a confirmation dialog.
 *
 * @param {Object} props - Component props.
 * @param {Function} props.handleExit - Function to handle the modal close event confirming exit.
 */
const RemoveProductModal = ({ handleExit, handleClose }: any) => {
	const dispatch = useDispatch();

	const { open: openState, params } = useSelector((state: RootState) => state.dialogSlice);
	const open = openState['removeProduct'];
	const productName = params['removeProduct']?.productName ?? 'this product';

	const handleCloseDialog = () => {
        handleClose();
		dispatch(closeDialog('removeProduct'));
	};

	const handleExitDialog = () => {
		dispatch(closeDialog('removeProduct'));
		handleExit();
	};

	return (
		<Dialog onClose={handleCloseDialog} open={open} className='modalConfirmation_container'>
			<DialogTitle>Remove product?</DialogTitle>
			<DialogContent>
				<Divider />
				<Box pt='1em'>
					<Typography variant='cardSubtitle1'>
						{`Please note that if you remove ${productName} from your quote, it will be
						abandoned and you will not be able to add it back without creating a new
						quote.`}
					</Typography>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button variant='text' onClick={handleCloseDialog}>
					Cancel
				</Button>
				<Button variant='contained' onClick={handleExitDialog}>
					Continue
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default RemoveProductModal;
